'use strict';

var Sugar = require('sugar-core'),
    createDateWithContext = require('./internal/createDateWithContext');

Sugar.Date.defineInstance({

  'get': function(date, d, options) {
    return createDateWithContext(date, d, options);
  }

});

module.exports = Sugar.Date.get;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/date/get.js
// module id = 183
// module chunks = 1